import { Button } from "@/components/shadcn/button";
import { LoadingButton } from "../../components/ui/Button";
import { TextInput } from "../../components/ui/form/TextInput";
import { useNavigate } from "@solidjs/router";
import useForgetPassword from "../../services/auth/useForgetPassword";

export default function ForgetPassword() {
  const { form, onFormInput, onSubmit, onForgetPassword, loading } = useForgetPassword();
  const navigate = useNavigate();

  const navigateToLoginPage = () => {
    navigate("/auth/login", { replace: true });
  }

  return (
    <div class="space-y-6">
      <div class="flex flex-col space-y-2 text-center">
        <h1 class="text-2xl font-semibold tracking-tight">
          Forget Password
        </h1>
        <p class="text-sm text-muted-foreground">
          Check your Email after submitting your request. Email will contain a password reset page and code to reset your password.
        </p>
      </div>
      <div class="grid gap-6">
        <form onSubmit={onSubmit}>
          <div class="grid gap-2">
            <div class="grid gap-1">
              <TextInput
                type="text"
                name="identity"
                form={form}
                loading={loading()}
                sr={true}
                input={onFormInput}
                label='Email or Username'
                placeholder="Email or Username" />
            </div>
            <div class="grid gap-1 mt-[5px]">
              <LoadingButton onClick={(e) => { onForgetPassword() }} loading={loading()}>Send Password Recovery Email</LoadingButton>
            </div>
          </div>
        </form>
        <div class="inset-0 flex items-center">
          <span class="w-full border-t" />
        </div>
        <Button variant="outline" onClick={() => { navigateToLoginPage() }} type="button" disabled={loading()}>
          Goto Login Page
        </Button>
      </div>
    </div>
  );
}
